'use client';

import { WithdrawalGuideContent } from '@features/withdrawal-guide';
import { observer } from 'mobx-react-lite';

import { BottomSheetUi } from '@/shared/ui/mobile/bottom-sheet';
import { useStore } from '@/store/context';

import styles from './styles.module.scss';

export const WithdrawalGuideModalMobile = observer(() => {
  const withdrawalStore = useStore().withdrawal;
  const game = useStore().app?.selectedGame;

  const handleCLose = () => {
    withdrawalStore.setGuideStep(null);
  };

  return (
    <BottomSheetUi
      handleClose={handleCLose}
      className={styles['modal']}
      isOpen={!!withdrawalStore.guideStep}
    >
      <WithdrawalGuideContent
        game={game}
        accountAge={withdrawalStore?.selectedAccountAge ?? 'above'}
        step={withdrawalStore.guideStep ?? 1}
        onClose={handleCLose}
      />
    </BottomSheetUi>
  );
});
